import React, { Component } from "react";
import { connect } from "react-redux";
import { LinearProgress } from "@material-ui/core";
import "../libs/styles/signin.css";
import {
  signinUserIn,
  setLoading,
  showMessage,
  handleAppError,
} from "../actions";
import { QRInsurancePDFIcon } from "../libs/SVGIcons";
import { ErrorBoundary } from "react-error-boundary";
import axios from "../axios";
import { Button } from "@material-ui/core";
import AppConfig from "../constants/AppConfig";
import { PricesCalculatorElement } from "../routes/home/components";

class Calculator extends Component {
  state = {
    details: null,
  };
  constructor() {
    super();
  }
  componentDidMount() {
    this.props.setLoading(false);
  }
  errorFallback({ error, resetErrorBoundary }) {
    return (
      <div role="alert">
        <p>{window.sys_app_translate("Something went wrong", "en")}:</p>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>
          {window.sys_app_translate("Try again", "en")}
        </button>
      </div>
    );
  }
  render() {
    const { loading, lang, setLoading, handleAppError } = this.props,
      { permissions } = this.props.user,
      { details } = this.state;
    return (
      <ErrorBoundary FallbackComponent={this.errorFallback} onReset={() => { }}>
        {loading && (
          <div
            className="container-fluid"
            style={{ position: "fixed", zIndex: "100000" }}
          >
            <LinearProgress color="primary" />
            <LinearProgress color="primary" />
          </div>
        )}
        <div className="container-fluid qr-page" style={{ height: "100vh" }}>
          <div className="row d-flex justify-content-center align-content-center">
            <div className="col-11 col-md-8 col-lg-5 col-xl-7 d-flex justify-content-center hasiba-container">
              <div className="container-fluid">
                <div className="row my-3">
                  <div className="col-12 text-center">
                    {/* TODO: Check or modify brand logo -i */}
                    {/* <img
                      style={{ height: "10rem" }}
                      src={require("../assets/system-agency-logo-for-qr-insurance-page.png")}
                    /> */}
                  </div>
                </div>
                <div className="row d-flex justify-content-center">
                  <PricesCalculatorElement
                    lang={lang}
                    setLoading={setLoading}
                    handleAppError={handleAppError}
                    isDiscountedPricesPermitted={true}
                    isPublic={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { user } = authUser;
  const { loading } = appReducer;
  return { user, loading };
};

export default connect(mapStateToProps, {
  signinUserIn,
  setLoading,
  showMessage,
  handleAppError,
})(Calculator);